













import { FontLoader } from '@/components/FontSelector'
import Vue from 'vue'
import DefaultCss from './defaultcss'
import EmojiText from '@/components/EmojiText'
import './LiveChatElement.scss'

export default Vue.extend({
  name: 'LiveChatElement',
  props: {
    width: {
      type: Number,
      required: false
    },
    height: {
      type: Number,
      required: false
    },
    css: {
      type: Object,
      required: true
    },
    chatMessage: {
      type: Object,
      required: true
    },
    numbers: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    defaultcss: DefaultCss,
  }),
  computed: {
    // background
    backgroundstyle (): any {
      return {
        'background-color': this.getValue('text', 'visible') ? this.getValue('background', 'color') : 'transparent',
        'border-radius': (this.showText) ? this.getPixelSize('largest', 'background', 'borderradius') + 'px' : 0
      }
    },
    message (): string {
      if (this.chatMessage?.data?.text) {
        return this.chatMessage.data.text
      }
      return ''
    },
    // username
    username (): string {
      if (this.chatMessage?.data?.user) {
        return this.chatMessage.data.user
      }
      return ''
    },
    showText (): boolean {
      return !!this.getValue('text', 'visible')
    },
    usernameStyle (): Partial<CSSStyleDeclaration> {
      const style: Partial<CSSStyleDeclaration> = {
        color: this.getValue('username', 'color'),
        marginLeft: this.getPixelSize('height', 'username', 'left') + 'px',
        marginTop: this.getPixelSize('height', 'username', 'top') + 'px',
        font: this.getValue('username', 'font'),
        fontFamily: this.getFontFamily('username', 'font'),
        fontSize: this.getPixelSize('largest', 'username', 'fontsize') / 3 + 'px'
      }
      return style
    },
    textstyle (): Partial<CSSStyleDeclaration> {
      const fontSize = this.getPixelSize('largest', 'text', 'fontsize') / 3
      const lineHeight = fontSize * 1.20

      const style: Partial<CSSStyleDeclaration> = {
        display: 'inline-flex',
        color: this.getValue('text', 'color'),
        font: this.getValue('text', 'font'),
        fontFamily: this.getFontFamily('text', 'font'),
        fontSize: fontSize+ 'px',
        lineHeight: lineHeight + 'px'
      }
      return style
    },
    emojiTextstyle (): Partial<CSSStyleDeclaration> {
      const margin = this.getPixelSize('height', 'text', 'left')

      const style: Partial<CSSStyleDeclaration> = {
        marginLeft:  margin + 'px',
        width: 'calc(100% - ' + (margin * 2) + 'px)',
        marginTop: this.getPixelSize('height', 'text', 'top') + 'px',
      }
      return style
    },
    overflowStyle (): Partial<CSSStyleDeclaration> {
      const bgColor = this.getValue('background', 'color')
      const fontSize = this.getPixelSize('largest', 'username', 'fontsize')

      const style: Partial<CSSStyleDeclaration> = {
        paddingBottom: `${fontSize}px`,
        background: bgColor,
        fontFamily: this.getFontFamily('text', 'font'),
        fontSize: this.getPixelSize('largest', 'text', 'fontsize') / 2 + 'px',
        height: fontSize * 1.5 + 'px'
      }
      return style
    }
  },
  methods: {
    getValue (component: string, tag: string) {
      let value = (this.defaultcss[component] && this.defaultcss[component][tag])
      if (value === undefined) {
        console.error(`Default CSS for ${component} / ${tag} not existing`)
        value = 0
      }
      if (this.css[component] && this.css[component][tag] !== undefined) {
        value = this.css[component][tag]
      }
      return value
    },
    getPixelSize (direction, component, tag) {
      const value = this.getValue(component, tag)
      if (direction === 'largest') return Math.max(this.height, this.width) * value / 100
      if (direction === 'width') return this.width * value / 100
      if (direction === 'height') return this.height * value / 100
      return 0
    },
    removeEmojis (text) {
      const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|[\ud83c[\ude50\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g
      return text.replace(regex, '')
    },
    getFontFamily (component, tag) {
      const font = this.getValue(component, tag)
      if (font) {
        return font + ', Work Sans, Helvetica, Arial, sans-serif'
      }
      return 'Work Sans, Helvetica, Arial, sans-serif'
    }
  },
  components: {
    FontLoader,
    EmojiText
  }
})
